import { MarketplaceComponentConfig } from '@nocode/types';

export default {
  name: 'TimeSlot',
  displayName: {
    en: 'TimeSlot',
    ja: 'TimeSlot',
  },
  icon: './icon.png',
  defaultWidth: 375,
  defaultHeight: 400,
  resizeY: true,
  resizeX: true,
  props: [
    {
      name: 'eventStarttime',
      role: 'formValue',
      type: 'date',
    },
    {
      name: 'availableStock',
      role: 'formValue',
      enabled: {
        'stockConfig.enabled': true,
      },
      type: 'number',
    },
    {
      name: 'items',
      displayName: {
        en: 'What events should be blocked?',
        ja: 'ブロックする時間を選択してください',
      },
      type: 'list',
      disableListOptions: true,
    },
    {
      name: 'blockStartTime',
      displayName: {
        en: 'Block Start Time',
        ja: 'ブロック開始日時',
      },
      role: 'listItem',
      reference: 'items',
      type: 'text',
      hideFormatting: true,
    },
    {
      name: 'blockEndTime',
      displayName: {
        en: 'Block End Time',
        ja: 'ブロック終了日時',
      },
      role: 'listItem',
      reference: 'items',
      type: 'text',
      hideFormatting: true,
    },
    {
      name: 'expandedTime',
      displayName: {
        en: 'Expanded Time (minutes)',
        ja: 'Expanded Time (minutes)',
      },
      type: 'number',
    },
    {
      name: 'timeDuration',
      displayName: {
        en: 'Time duration',
        ja: '時間間隔',
      },
      type: 'text',
      default: '30',
      control: {
        type: 'menu',
        options: [
          {
            label: '15 minutes',
            value: 15,
          },
          {
            label: '30 minutes',
            value: 30,
          },
          {
            label: '45 minutes',
            value: 45,
          },
          {
            label: '60 minutes',
            value: 60,
          },
          {
            label: '90 minutes',
            value: 90,
          },
        ],
      },
    },
    {
      name: 'dayViewNumber',
      displayName: {
        en: 'Number of day to display',
        ja: 'Number of day to display',
      },
      type: 'text',
      default: '7d',
      control: {
        type: 'menu',
        options: [
          {
            label: '3日',
            value: '3days',
          },
          {
            label: '4日',
            value: '4days',
          },
          {
            label: '5日',
            value: '5days',
          },
          {
            label: '7日',
            value: '7days',
          },
          {
            label: '1ヶ月',
            value: '1month',
          },
        ],
      },
    },
    {
      name: 'successActions',
      displayName: {
        en: 'Actions when this time is available',
        ja: '利用可能時のアクション',
      },
      type: 'action',
    },
    {
      name: 'failedActions',
      displayName: {
        en: 'Actions when this time is not available',
        ja: '利用不可時のアクション',
      },
      type: 'action',
    },
    {
      name: 'askingActions',
      displayName: {
        en: 'Actions when this time is asking',
        ja: '要確認時のアクション',
      },
      type: 'action',
      enabled: {
        'customAskingTime.enabled': true,
      },
    },
  ],
  childComponents: [
    {
      name: 'stockConfig',
      displayName: {
        en: 'Stock Config',
        ja: '在庫設定',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: true,
        },
        {
          name: 'maximumStock',
          type: 'number',
          displayName: {
            en: 'Maximum Stock',
            ja: '最大在庫数',
          },
          default: 1,
        },
        {
          name: 'stockUsedCount',
          type: 'number',
          role: 'listItem',
          reference: 'items',
          displayName: {
            en: 'Stock Used Count',
            ja: '予約済み在庫数',
          },
          default: 0,
        },
      ],
    },
    {
      name: 'customInitializeTime',
      displayName: {
        en: 'Custom current time',
        ja: 'カスタム日時',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: 'true',
        },
        {
          name: 'hour',
          type: 'number',
          placeholder: 'Current hour',
          displayName: {
            en: 'Hour (24h format)',
            ja: '時間(24時間)',
          },
        },
        {
          name: 'minute',
          type: 'number',
          displayName: {
            en: 'Minute',
            ja: '分',
          },
        },
      ],
    },
    {
      name: 'customAskingTimeSameDay',
      displayName: {
        en: 'Custom Asking time same day',
        ja: '要確認時のブロック時間（当日）',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'time',
          type: 'text',
          placeholder: '16:00',
          displayName: {
            en: 'Time',
            ja: '時間',
          },
        },
        {
          name: 'label',
          type: 'text',
          placeholder: 'Label',
          displayName: {
            en: 'Label',
            ja: 'ラベル',
          },
        },
        {
          name: 'color',
          type: 'color',
          displayName: {
            en: 'Color',
            ja: '色',
          },
        },
        {
          name: 'fontSize',
          type: 'fontSize',
          displayName: {
            en: 'Font size',
            ja: '文字のサイズ',
          },
        },
        {
          name: 'fontFamily',
          type: 'fontFamily',
          displayName: {
            en: 'Font family',
            ja: '文字の種類',
          },
        },
        {
          name: 'textAlignment',
          type: 'textAlignment',
          displayName: {
            en: 'Text alignment',
            ja: '文字の配置',
          },
        },
      ],
    },
    {
      name: 'customAskingTimeNextDay',
      displayName: {
        en: 'Custom Asking time next day',
        ja: '要確認時のブロック時間（翌日）',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'time',
          type: 'text',
          placeholder: '16:00',
          displayName: {
            en: 'Time',
            ja: '時間',
          },
        },
        {
          name: 'label',
          type: 'text',
          placeholder: 'Label',
          displayName: {
            en: 'Label',
            ja: 'ラベル',
          },
        },
        {
          name: 'color',
          type: 'color',
          displayName: {
            en: 'Color',
            ja: '色',
          },
        },
        {
          name: 'fontSize',
          type: 'fontSize',
          displayName: {
            en: 'Font size',
            ja: '文字のサイズ',
          },
        },
        {
          name: 'fontFamily',
          type: 'fontFamily',
          displayName: {
            en: 'Font family',
            ja: '文字の種類',
          },
        },
        {
          name: 'textAlignment',
          type: 'textAlignment',
          displayName: {
            en: 'Text alignment',
            ja: '文字の配置',
          },
        },
      ],
    },
    {
      name: 'customMondayTime',
      displayName: {
        en: 'Custom Monday time',
        ja: '月曜日の営業時間',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'from',
          type: 'text',
          placeholder: '09:00',
          displayName: {
            en: 'Start time',
            ja: '営業開始時間',
          },
        },
        {
          name: 'to',
          type: 'text',
          placeholder: '19:00',
          displayName: {
            en: 'End time',
            ja: '営業終了時間',
          },
        },
      ],
    },
    {
      name: 'customTuesdayTime',
      displayName: {
        en: 'Custom Tuesday time',
        ja: '火曜日の営業時間',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'from',
          type: 'text',
          placeholder: '09:00',
          displayName: {
            en: 'Start time',
            ja: '営業開始時間',
          },
        },
        {
          name: 'to',
          type: 'text',
          placeholder: '19:00',
          displayName: {
            en: 'End time',
            ja: '営業終了時間',
          },
        },
      ],
    },
    {
      name: 'customWednesdayTime',
      displayName: {
        en: 'Custom Wednesday time',
        ja: '水曜日の営業時間',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'from',
          type: 'text',
          placeholder: '09:00',
          displayName: {
            en: 'Start time',
            ja: '営業開始時間',
          },
        },
        {
          name: 'to',
          type: 'text',
          placeholder: '19:00',
          displayName: {
            en: 'End time',
            ja: '営業終了時間',
          },
        },
      ],
    },
    {
      name: 'customThursdayTime',
      displayName: {
        en: 'Custom Thursday time',
        ja: '木曜日の営業時間',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'from',
          type: 'text',
          placeholder: '09:00',
          displayName: {
            en: 'Start time',
            ja: '営業開始時間',
          },
        },
        {
          name: 'to',
          type: 'text',
          placeholder: '19:00',
          displayName: {
            en: 'End time',
            ja: '営業終了時間',
          },
        },
      ],
    },
    {
      name: 'customFridayTime',
      displayName: {
        en: 'Custom Friday time',
        ja: '金曜日の営業時間',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'from',
          type: 'text',
          placeholder: '09:00',
          displayName: {
            en: 'Start time',
            ja: '営業開始時間',
          },
        },
        {
          name: 'to',
          type: 'text',
          placeholder: '19:00',
          displayName: {
            en: 'End time',
            ja: '営業終了時間',
          },
        },
      ],
    },
    {
      name: 'customSaturdayTime',
      displayName: {
        en: 'Custom Saturday time',
        ja: '土曜日の営業時間',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'from',
          type: 'text',
          placeholder: '09:00',
          displayName: {
            en: 'Start time',
            ja: '営業開始時間',
          },
        },
        {
          name: 'to',
          type: 'text',
          placeholder: '19:00',
          displayName: {
            en: 'End time',
            ja: '営業終了時間',
          },
        },
      ],
    },
    {
      name: 'customSundayTime',
      displayName: {
        en: 'Custom Sunday time',
        ja: '日曜日の営業時間',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'from',
          type: 'text',
          placeholder: '09:00',
          displayName: {
            en: 'Start time',
            ja: '営業開始時間',
          },
        },
        {
          name: 'to',
          type: 'text',
          placeholder: '19:00',
          displayName: {
            en: 'End time',
            ja: '営業終了時間',
          },
        },
      ],
    },
    {
      name: 'latestBookStartTime',
      displayName: {
        en: 'Latest Book Start Time',
        ja: '最新日の予約開放時間',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'time',
          type: 'text',
          placeholder: '09:00',
          displayName: {
            en: 'Time',
            ja: '最新日の予約開放時間',
          },
        },
      ],
    },
    {
      name: 'styles',
      displayName: {
        en: 'Style',
        ja: 'Style',
      },
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: false,
        },
        {
          name: 'dayWidth',
          displayName: {
            en: 'Day width',
            ja: 'Day width',
          },
          type: 'number',
          conditions: {
            min: 20,
            error: 'Value must >= 20',
          },
          disableDynamicValues: true,
        },
        {
          name: 'availableColor',
          displayName: {
            en: 'Available color',
            ja: '利用可能時の色',
          },
          type: 'color',
        },
        {
          name: 'notAvailableColor',
          displayName: {
            en: 'Not Available color',
            ja: '利用不可時の色',
          },
          type: 'color',
        },
        {
          name: 'saturdayColor',
          displayName: {
            en: 'Saturday color',
            ja: '土曜日の色',
          },
          type: 'color',
        },
        {
          name: 'holidayColor',
          displayName: {
            en: 'Holiday color',
            ja: '日曜・祝日の色',
          },
          type: 'color',
        },
      ],
    },
    // navigation props
    {
      name: 'navigation',
      displayName: {
        en: 'Navigation',
        ja: '選択日のオプション',
      },
      props: [
        {
          name: 'defDate',
          displayName: {
            en: 'Begin date',
            ja: '開始日',
          },
          placeholder: 'YYYY-MM-DD',
          type: 'text',
          hideFormatting: true,
          defaultFormatType: 'YYYY/MM/DD',
        },
        {
          name: 'minDate',
          displayName: {
            en: 'Earliest Selectable Date',
            ja: '選択可能な開始日',
          },
          type: 'text',
          default: '2025-01-01',
          placeholder: 'YYYY-MM-DD',
          hideFormatting: true,
          defaultFormatType: 'YYYY/MM/DD',
        },
        {
          name: 'maxDate',
          displayName: {
            en: 'Latest Selectable Date',
            ja: '選択可能な終了日',
          },
          type: 'text',
          default: '2030-01-01',
          placeholder: 'YYYY-MM-DD',
          hideFormatting: true,
          defaultFormatType: 'YYYY/MM/DD',
        },
      ],
    },
  ],
} as MarketplaceComponentConfig;
